import React from 'react';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';

import { Gallery, Item } from 'react-photoswipe-gallery';

// Gallery items data for cleaner code
const galleryItems = [
  { name: 'Bachelor Summit', alt: 'The summit of Mount Bachelor in Bend Oregon.' },
  { name: 'Death Valley', alt: 'An overlook in Death Valley National Park.' },
  { name: 'Dillan', alt: 'Sunset over the top of mountains right outside Dillan, Colorado.' },
  { name: 'Fall Creek', alt: 'A dog overlooking Fall Creek in Idaho.' },
  { name: 'Little Si', alt: 'Dog in nature.' },
  { name: 'Milky Way', alt: 'The Milky way outside of Bear Creek Hot Springs.' },
  { name: 'Rufus', alt: 'Dog overlooking the Columbia River Valley in Rufus, Oregon.' },
  { name: 'Todd Lake', alt: 'A dog overlooking Todd Lake with Broken Top in the background.' },
  { name: 'Wolf Flats', alt: 'An overlook at Wolf Flats in Idaho.' },
];

const MyGallery = () => (
  <Gallery>
    {galleryItems.map((item) => (
      <Item
        key={item.name}
        original={`gallery/${item.name}.jpg`}
        thumbnail={`gallery/Thumbnails/${item.name}.jpg`}
        width="2048"
        height="1536"
    >
      {({ ref, open }) => (
          <img
            ref={ref}
            onClick={open}
            src={`gallery/Thumbnails/${item.name}.jpg`}
            width="33.33%"
            alt={item.alt}
            loading="lazy"
            decoding="async"
          />
      )}
    </Item>
    ))}
  </Gallery>
);

export default MyGallery;



// WEBPACK FOOTER //
// ./src/Components/Gallery.js